import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from 'react';
import api from '@/lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('alumfab_token');
    if (!token) {
      setLoading(false);
      return;
    }
    api.get('/auth/me')
      .then((res) => setUser(res.data))
      .catch(() => localStorage.removeItem('alumfab_token'))
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    localStorage.setItem('alumfab_token', res.data.token);
    setUser(res.data.user);
    return res.data.user;
  }, []);

  const register = useCallback(async (nama, email, password, shop_name) => {
    const res = await api.post('/auth/register', { nama, email, password, shop_name });
    localStorage.setItem('alumfab_token', res.data.token);
    setUser(res.data.user);
    return res.data.user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('alumfab_token');
    setUser(null);
    window.location.href = '/login';
  }, []);

  const value = useMemo(() => ({
    user, loading, login, register, logout,
    role: user?.role,
    isOwner: user?.role === 'owner',
    isStaff: user?.role === 'staff',
    isField: user?.role === 'field',
    isSuperAdmin: user?.role === 'super_admin',
  }), [user, loading, login, register, logout]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
